// Create a new file called context.js

import React, { createContext, useState } from 'react';

// Create a context object
export const GlobalContext = createContext();

// Create a provider component to wrap your entire app
export const GlobalProvider = ({ children }) => {
  // Define your global state variables
  const [gbStAdmins, setGbStAdmins] = useState([]);
  const [gbStBooksCategories,setGbStBooksCategories]=useState([]);
  const [gbStSessionYear,setGbStSessionYear]=useState([]);
  const [gbStCurriculum,setGbStCurriculum]=useState([]);  
  const [gbStAcademicProg,setGbStAcademicProgram]=useState([]);

  // Create functions to modify the global state

  const setGbAcademicProgram=(listAcademicProg)=>{
    setGbStAcademicProgram(listAcademicProg);
  }
  const setGbCurriculum=(listCurriculum)=>{
    setGbStCurriculum(listCurriculum);
  }

  const setGbSessionYear=(listSessionYear)=>{
    setGbStSessionYear(listSessionYear);
  }

  const setAdminsMaster=(listEmployeeMaster)=>{
    setGbStAdmins(listEmployeeMaster);
  }

  const setBooksCategories=(listBooksCategories)=>{
    setGbStBooksCategories(listBooksCategories);
  }

  // Provide the state and functions to the entire app through the context provider
  return (
    <GlobalContext.Provider value={{ gbStAdmins,setAdminsMaster,gbStCurriculum,setGbCurriculum,
      gbStBooksCategories,setGbStBooksCategories,gbStSessionYear,setGbSessionYear,
      gbStAcademicProg,setGbAcademicProgram }}>
      {children}
    </GlobalContext.Provider>
  );
};